/**
 * Module Bootstrap Code.
 *
 * @author Sadi Qevani
 */

(function (window, document, $) {
  "use strict";

  window.googleMaps = function () {

    if (!document.getElementById("googleMap")) return null;

    // Create a map object and specify the DOM element for display.
    var map = new google.maps.Map(document.getElementById("googleMap"), {
      center: {lat: 39.8864481, lng: -74.981053},
      scrollwheel: false,
      zoom: 11
    });

    var marlton = new google.maps.Marker({
      position: {lat: 39.8957904, lng: -74.9293763},
      map: map,
      title: 'IMAGE BEAUTY SALON & STORE MARLTON',
      icon: '{{ "location-marlton.svg" | asset_url }}'
    });

    var springs = new google.maps.Marker({
      position: {lat: 39.8188726, lng: -75.0386176},
      map: map,
      title: 'IMAGE BEAUTY SALON & STORE MEDFORD',
      icon: '{{ "location-medford.svg" | asset_url }}'
    });
  };

}(window, document, jQuery));
